export const PRODUCT_CAT_PICKER_LOADING = 'PRODUCT_CAT_PICKER_LOADING';
export const PRODUCT_CAT_PICKER_DATA = 'PRODUCT_CAT_PICKER_DATA';
export const PRODUCT_CAT_PICKER_ERROR = 'PRODUCT_CAT_PICKER_ERROR';
export const PRODUCT_CAT_PICKER_SELECT = 'PRODUCT_CAT_PICKER_SELECT';
